<template>

	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-table :data="dailyData" border style="width: 100%">
			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="uname" label="用户">
			</el-table-column>
			<el-table-column prop="description" label="描述">
			</el-table-column>
			<el-table-column prop="ip" label="ip地址">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间">
			</el-table-column>
			<el-table-column prop="action" label="操作" v-if='false'>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="success" @click="handleDetail(scope.row)" icon="el-icon-view">查看</el-button>
				</template>
			</el-table-column>

		</el-table>
		<el-dialog :visible.sync="handle" width="30%" style="font-weight:bold;">
			<div>
				<pre>{{action}}</pre>
			</div>
		</el-dialog>
		<!-- <el-dialog :title="dialogUserInfo.elderName+'的资料'" :visible.sync="detail_dv" width="30%" style="font-weight:bold;">
			<plat-detail :dialogUserInfo="dialogUserInfo" :detail_loading="detail_loading"></plat-detail>
		</el-dialog> -->
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import mybread from "@/components/bread"
	export default {
		components: {
			mybread
		},
		data() {
			return {
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				dailyData: [],
				detail_dv: false,
				detail_loading: false,
				dialogUserInfo: [],
				handle: false,
				action: "",
				list_loading:true
			}
		},
		created() {
			this.getDailyData()
		},

		methods: {
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getDailyData();
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getDailyData();
			},
			getDailyData() {
				const data = {
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize
				}
				this.$get("api/log/listData", data).then(res => {
					window.console.log(111)
					window.console.log(res)
					this.dailyData = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
				}).catch((e) => {
					window.console.log(e)
				})

			},
			handleDetail(row) {
				this.handle = true
				//在Vue生命周期的created()钩子函数进行的DOM操作一定要放在Vue.nextTick()的回调函数中
				//在created()钩子函数执行的时候DOM 其实并未进行任何渲染，而此时进行DOM操作无异于徒劳，
				//所以此处一定要将DOM操作的js代码放进Vue.nextTick()的回调函数中。
				//与之对应的就是mounted()钩子函数，因为该钩子函数执行时所有的DOM挂载和渲染都已完成，
				//此时在该钩子函数中进行任何DOM操作都不会有问题 。
				this.$nextTick(() => { //不需要详情接口，从列表中直接读取查看数据
					this.action = JSON.parse(row.action);
				});
			},

		},
	}
</script>

<style scoped="scoped">
	.main .block {
		text-align: center;
		margin-top: 20px;
	}

	.main {
		background: #fff;
		padding: 0 20px 20px 20px;
	}
</style>
